// This file was autogenerated from `scripts/gen_entity_record_columns.py`, and should not be
// modified by hand.

/** The kind of JSON value a record holds under one top-level key: a JSON
 *  type, or `date-time` for an ISO 8601 timestamp string. */
export type EntityRecordValueKind =
  | "array"
  | "boolean"
  | "date-time"
  | "integer"
  | "number"
  | "object"
  | "string";

/** For each target a board can query, the top-level keys of the records
 *  the query results route returns, except `metadata`, in the record
 *  models' order, with the kind of value each holds. */
export const entityRecordColumns = {
  collections: {
    collection_id: "string",
    name: "string",
    description: "string",
    resource_type: "string",
    resources: "object",
    missing: "object",
    resource_count: "integer",
    tags: "array",
    custom_fields: "object",
    version: "integer",
    created: "date-time",
    created_by: "string",
    updated: "date-time",
    updated_by: "string",
    org_id: "string",
  },
  datasets: {
    created: "date-time",
    created_by: "string",
    dataset_id: "string",
    description: "string",
    device_id: "string",
    custom_fields: "object",
    modified: "date-time",
    modified_by: "string",
    name: "string",
    org_id: "string",
    roboto_record_version: "integer",
    tags: "array",
    administrator: "string",
    storage_ctx: "object",
    storage_location: "string",
  },
  devices: {
    created: "date-time",
    created_by: "string",
    device_id: "string",
    universal_device_id: "string",
    modified: "date-time",
    modified_by: "string",
    org_id: "string",
    device_type_id: "string",
    custom_fields: "object",
    tags: "array",
  },
  events: {
    associations: "array",
    created: "date-time",
    created_by: "string",
    description: "string",
    end_time: "integer",
    event_id: "string",
    custom_fields: "object",
    modified: "date-time",
    modified_by: "string",
    name: "string",
    org_id: "string",
    start_time: "integer",
    tags: "array",
    display_options: "object",
    session_id: "string",
    topics: "array",
  },
  files: {
    association_id: "string",
    created: "date-time",
    created_by: "string",
    description: "string",
    device_id: "string",
    file_id: "string",
    fs_type: "string",
    ingestable: "boolean",
    ingestion_status: "string",
    modified: "date-time",
    modified_by: "string",
    name: "string",
    org_id: "string",
    origination: "string",
    parent_id: "string",
    relative_path: "string",
    size: "integer",
    status: "string",
    storage_type: "string",
    tags: "array",
    upload_id: "string",
    uri: "string",
    version: "integer",
  },
  sessions: {
    completed_at: "date-time",
    completed_by: "string",
    completes_at: "date-time",
    completion_policy: "object",
    created: "date-time",
    created_by: "string",
    custom_fields: "object",
    description: "string",
    ingested_at: "date-time",
    ingestion_count: "integer",
    max_timestamp_ns: "integer",
    min_timestamp_ns: "integer",
    modified: "date-time",
    modified_by: "string",
    name: "string",
    org_id: "string",
    session_id: "string",
    status: "string",
    tags: "array",
  },
} as const satisfies Record<string, Record<string, EntityRecordValueKind>>;
